import { PureComponent, ReactNode } from 'react';
import { AntTooltip } from '../../../../common/AntTooltip';

interface Props {
    tooth: string;
    seventhSurfaceName: string;
    isSeventhSurfaceSelected: boolean;
    selectSurface: (teeth: string, surface: number) => void;
    isForLowerTeeth?: boolean;
}

class SeventhSurface extends PureComponent<Props> {
    render(): ReactNode {
        const {
            tooth,
            seventhSurfaceName,
            isSeventhSurfaceSelected,
            selectSurface,
            isForLowerTeeth,
        } = this.props;

        return (
            <AntTooltip content={seventhSurfaceName} placement="right" mouseEnterDelay={0.5}>
                <svg
                    className={`w-21 h-14 cursor-pointer ${
                        isForLowerTeeth ? 'mt-3 mb-5' : 'mt-5 mb-3'
                    }`}
                    viewBox="0 0 21 14"
                    xmlns="http://www.w3.org/2000/svg"
                    style={isForLowerTeeth ? { transform: 'rotate(180deg)' } : undefined}
                >
                    <path
                        d="M9.01856 2.23654C9.53413 1.63399 10.4659 1.63399 10.9814 2.23654L18.5526 11.085C19.2697 11.9231 18.6741 13.2165 17.5711 13.2165H2.42887C1.32585 13.2165 0.730325 11.9231 1.44743 11.085L9.01856 2.23654Z"
                        fill={isSeventhSurfaceSelected ? '#D1EDE1' : '#F4F4F4'}
                        stroke={isSeventhSurfaceSelected ? '#19A66A' : '#BABABA'}
                        stroke-width="1.41667"
                        onClick={() => selectSurface(tooth, 7)}
                    />
                </svg>
            </AntTooltip>
        );
    }
}

export default SeventhSurface;
